import { ModalName, ModalsMapType } from './types';

import {
    AdditionalContentOfferModal,
    CancellationReasonModal,
    CanNotLoginModal,
    CompletePersonalPlanModal,
    ConfirmationModalWithDiscount,
    DiscountModal,
    ExpiredSubscriptionDiscountErrorModal,
    FitnessLevelModal,
    FreeMonthModal,
    GoalModal,
    NoConnectionModal,
    NoLogInModal,
    PauseModal,
    ProblemZonesModal,
    QuitWorkoutModal,
    ReminderModal,
    ResizableNotificationModal,
    RestoreSubscriptionModal,
    RetryErrorModal,
    ReturnModal,
    SuccessModal,
    WithLoaderModal,
    ServerErrorModal,
    CopyCodeErrorModal,
} from './modalsExports';

export const MODALS_LIST: ModalsMapType = {
    [ModalName.DiscountModal]: DiscountModal,
    [ModalName.CancellationReasonModal]: CancellationReasonModal,
    [ModalName.WithLoaderModal]: WithLoaderModal,
    [ModalName.SuccessModal]: SuccessModal,
    [ModalName.NoConnectionModal]: NoConnectionModal,
    [ModalName.QuitWorkoutModal]: QuitWorkoutModal,
    [ModalName.CompletePersonalPlanModal]: CompletePersonalPlanModal,
    [ModalName.GoalModal]: GoalModal,
    [ModalName.ProblemZonesModal]: ProblemZonesModal,
    [ModalName.FitnessLevelModal]: FitnessLevelModal,
    [ModalName.RestoreSubscriptionModal]: RestoreSubscriptionModal,
    [ModalName.CanNotLoginModal]: CanNotLoginModal,
    [ModalName.ReminderModal]: ReminderModal,
    [ModalName.FreeMonthModal]: FreeMonthModal,
    [ModalName.RetryErrorModal]: RetryErrorModal,
    [ModalName.AdditionalContentOfferModal]: AdditionalContentOfferModal,
    [ModalName.PauseModal]: PauseModal,
    [ModalName.ConfirmationModalWithDiscount]: ConfirmationModalWithDiscount,
    [ModalName.ReturnModal]: ReturnModal,
    [ModalName.ResizableNotificationModal]: ResizableNotificationModal,
    [ModalName.ExpiredSubscriptionDiscountErrorModal]: ExpiredSubscriptionDiscountErrorModal,
    [ModalName.NoLogInModal]: NoLogInModal,
    [ModalName.ServerErrorModal]: ServerErrorModal,
    [ModalName.CopyCodeErrorModal]: CopyCodeErrorModal,
};
